const MODULE_ID = 'documents';
export default MODULE_ID;
